module.exports = __webpack_public_path__ + "static/media/copy.b924f9e5.svg";